export enum ConsignmentPodAttachmentTypeEnum {
  Pod = 0,
  Invoice
}
